import { includes, pickBy } from 'ramda';

const countries = (process.env.REACT_APP_COUNTRY || 'ru,by,kz,uz').split(',');
const checkCountry = code => includes(code, countries) ? code : '';

export const RU = checkCountry('ru');
export const BY = checkCountry('by');
export const KZ = checkCountry('kz');
export const UZ = checkCountry('uz');

export const codes = {
    '1': RU,
    '3': BY,
    '4': KZ,
    '168': UZ,
};

const defaultLanguages = ['ru', 'en'];

export const languages = pickBy((value, key) => Boolean(key), {
    [RU]: defaultLanguages,
    [KZ]: defaultLanguages,
    [UZ]: defaultLanguages,
    [BY]: defaultLanguages,
});

export const defaultCode = '1';

export const COUNTRIES = [
    { value: RU, code: '1' },
    { value: UZ, code: '168' },
    { value: KZ, code: '4' },
    { value: BY, code: '3' },
];
